import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { BaseComponent } from '@core/components/base-component';
import { UserDto } from '@interfaces/UserDto';
import { TranslateService } from '@ngx-translate/core';
import { Flags } from '@shared/services/models/flags.enum';
import { UserService } from '@shared/services/user.service';
import { LicenseAppModule } from '../shared/services/license.service';
import { SettingsService } from './shared/settings.service';

@Component({
  selector: 'pop-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.less']
})
export class SettingsComponent extends BaseComponent implements OnInit {
  public authorizedRole = 'app-admin';
  public estimateChanges = false;
  public ifChanges = false;
  public isSaving = false;
  public licenseAppModule = LicenseAppModule;
  public user?: UserDto;
  public Flags = Flags;

  public constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private userService: UserService,
    private settingsService: SettingsService
  ) {
    super();
  }

  public ngOnInit() {
    this.subscribe(
      this.settingsService.getNeedsSave().subscribe(needsSave => {
        this.ifChanges = needsSave;
      })
    );

    this.subscribe(
      this.userService.getUser().subscribe(u => {
        if (u.roles.filter(r => r.name === this.authorizedRole).length === 0) {
          void this.router.navigate(['/app/unauthorized']);
        }
        this.user = u;
      })
    );
  }

  private openSnackBar(action: string) {
    this.snackBar.open(this.translate.instant('MODAL.SAVED') as string, action, {
      duration: 3500
    });
  }

  public async saveSettings() {
    this.isSaving = true;
    await this.settingsService.saveSettings();
    this.openSnackBar('');
    this.isSaving = false;
  }
}
